(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
            document.addEventListener("DOMContentLoaded", function () {
                function updateTabs() {
                    const isMobile = window.matchMedia("(max-width: 1024.9px)").matches;
                    const labels = document.querySelectorAll(".tab-label");
                    const contents = document.querySelectorAll(".tab-content");
                    const contentsContainer = document.querySelector(".tab-contents");

                    if (isMobile) {
                        // Sortiere Inhalte direkt unter die Labels
                        labels.forEach((label, index) => {
                            const content = contents[index];
                            if (label.nextElementSibling !== content) {
                                label.parentNode.insertBefore(content, label.nextSibling);
                            }

                            // Click-Event für Akkordeon-Verhalten
                            label.addEventListener("click", function () {
                                const isActive = label.classList.contains("active");

                                labels.forEach((lbl) => lbl.classList.remove("active"));
                                contents.forEach((cnt) => cnt.style.display = "none");

                                if (!isActive) {
                                    label.classList.add("active");
                                    content.style.display = "flex";
                                }
                            });
                        });

                        // Ersten Tab aktivieren (nur wenn keiner aktiv ist)
                        const noActive = [...labels].every(label => !label.classList.contains("active"));
                        if (noActive && labels.length > 0 && contents.length > 0) {
                            labels[0].classList.add("active");
                            contents[0].style.display = "flex";
                        }

                    } else {
                        // Desktop-Modus: Inhalte zurücksortieren
                        contents.forEach((content, index) => {
                            if (content.parentNode !== contentsContainer) {
                                contentsContainer.appendChild(content);
                            }

                            // Sichtbarkeit durch :checked im CSS, also keine inline styles!
                            content.style.display = "";
                        });

                        // Alle Labels zurücksetzen (CSS :checked übernimmt die Anzeige)
                        labels.forEach(label => label.classList.remove("active"));
                    }
                }

                  setTimeout(updateTabs, 10);
   
            });
          
  } catch(e) { console.error(e); }
})();
})();
